import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/App.css';
import "./index.css";
import { Provider } from 'react-redux';
import userStore from 'store/store';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={userStore}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);
